/* ------------------------------------------------General function------------------------------------------------- */
export const constructDisplayNumber = (number, decimal = 2) => {
  const numberWithDecimal = Number(number).toFixed(decimal);
  const numberWithDecimalAndComma = numberWithDecimal.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return numberWithDecimalAndComma;
};

export const getSingularOrPluralLabel = (
  amount,
  singularLabel,
  { pluralLabel, labelOnly } = {}
) => {
  const returnLabel =
    amount === 1 ? singularLabel : pluralLabel || `${singularLabel}s`;
  const returnAmount = labelOnly ? "" : amount;

  return `${returnAmount} ${returnLabel}`.trim();
};

export const guard = (callback, fallbackValue) => {
  try {
    const value = callback();
    if (value === undefined || value === null) {
      return fallbackValue;
    }

    return value;
  } catch {
    return fallbackValue;
  }
};

export const checkHasValue = (value) => {
  return value !== undefined && value !== null;
};

export const checkObjectExistsAndNotEmpty = (object) => {
  return (
    object &&
    Object.keys(object).length > 0 &&
    !!Object.values(object).find((val) => val)
  );
};

/* ------------------------------------------------Specific function------------------------------------------------- */
// Rate
export const constructDisplayPrice = (
  feeAmount = 0,
  prefix = "" /* prefix = 'RM' */
) => {
  const displayFee = String(constructDisplayNumber(feeAmount));
  const displayFeeWithPrefix = prefix ? `${prefix} ${displayFee}` : displayFee;

  return displayFeeWithPrefix;
};

export const constructShortenedFinancialNumber = (number, prefix = "RM") => {
  if (number >= 1000000000000) {
    return (
      (prefix ? `${prefix} ` : "") +
      (number / 1000000000000).toFixed(1).replace(/\.0$/, "") +
      " Tril"
    );
  }
  if (number >= 1000000000) {
    return (
      (prefix ? `${prefix} ` : "") +
      (number / 1000000000).toFixed(1).replace(/\.0$/, "") +
      " Bil"
    );
  }
  if (number >= 1000000) {
    return (
      (prefix ? `${prefix} ` : "") +
      (number / 1000000).toFixed(1).replace(/\.0$/, "") +
      " Mil"
    );
  }
  if (number >= 1000) {
    return (
      (prefix ? `${prefix} ` : "") +
      (number / 1000).toFixed(1).replace(/\.0$/, "") +
      "K"
    );
  }
  return constructDisplayPrice(number, prefix);
};

// Constant Label
export const getLabelOfConstant = (
  selectedConstant,
  constants,
  constantField = "value"
) => {
  const foundConstant =
    constants.length > 0 &&
    constants.find((constant) => constant[constantField] === selectedConstant);

  // console.log("foundConstant", foundConstant);

  return foundConstant && foundConstant.label;
};

export const constructDisplayPercentage = (rate = 0, hasSuffix = true) => {
  const displayRate = (Number(rate) * 100).toFixed(2);
  const displayRateWithSuffix = hasSuffix ? `${displayRate}%` : displayRate;

  return displayRateWithSuffix;
};

export const capitalizeFirstLetter = (
  str,
  options = { lowerOthers: false }
) => {
  str = String(str);
  return options.lowerOthers
    ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    : str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertVariableNameToReadableString = (str) => {
  return capitalizeFirstLetter(str)
    .match(/[A-Z][a-z]+/g)
    .join(" ");
};

export const randomNumberGenerator = () =>
  Math.floor(Math.random() * 10000000000);

export const generateUniqueKey = (prefix = "") => {
  return `${prefix}_${new Date().getTime()}_${randomNumberGenerator()}`;
};
